import React from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

export const RecentlyViewed = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  return (
    <div className="xl:px-16 xl:mb-20 px-8 mb-10">
      <hr className="my-10" />
      <h2 className="text-xl mb-4">Recently Viewed Products</h2>
      <div className="recently_viewd new_arrivals">
        <Carousel responsive={responsive} infinite={true}>
          <Link to="" className="text-center">
            <img src="images/frame-1.jpeg" alt="Geometric" />
            <h3 className="text-gray-600 mb-1 text-sm">Vincent Chase Online</h3>
            <p className="text-gray-600">$299</p>
          </Link>
          <Link to="" className="text-center">
            <img src="images/frame-2.jpeg" alt="Round" />
            <h3 className="text-gray-600 mb-1 text-sm">Vincent Chase Online</h3>
            <p className="text-gray-600">$299</p>
          </Link>
          <Link to="" className="text-center">
            <img src="images/frame-3.jpeg" alt="Cat-Eye" />
            <h3 className="text-gray-600 mb-1 text-sm">Vincent Chase Online</h3>
            <p className="text-gray-600">$299</p>
          </Link>
          <Link to="" className="text-center">
            <img src="images/frame-4.jpeg" alt="Transparent" />
            <h3 className="text-gray-600 mb-1 text-sm">Vincent Chase Online</h3>
            <p className="text-gray-600">$299</p>
          </Link>
          <Link to="" className="text-center">
            <img src="images/frame-5.jpeg" alt="Geometric" />
            <h3 className="text-gray-600 mb-1 text-sm">Vincent Chase Online</h3>
            <p className="text-gray-600">$299</p>
          </Link>
          <Link to="" className="text-center">
            <img src="images/frame-5.jpeg" alt="Cat-Eye" />
            <h3 className="text-gray-600 mb-1 text-sm">Vincent Chase Online</h3>
            <p className="text-gray-600">$299</p>
          </Link>
        </Carousel>
      </div>
    </div>
  )
}